import CDialog from "core/components/CDialog";
import { config } from "core/config/app";
import { useFetchAppSetting } from "modules/AppSettings/hooks";
import { fetchMe } from "modules/Auth/store/actions";
import { useEffect, useState } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import uuid from "react-uuid";
import "./App.scss";
import "swiper/css";
import "swiper/css/pagination";
import AppPopup from "./core/components/AppPopup";
import useHandleError from "./core/hooks/useHandleError";
import {
  initApplication,
  settingApplication,
  setupAxios,
} from "./core/networks/API";
import { AppRouter } from "./core/router";
import { setDebugLog, setNativeReady } from "./core/store/actions";
import { deviceStorage } from "./core/utils/devicestorage";


import Lottie from "lottie-react";
import pwa from "pwa.json";

import {
  EXPIRE_TOKEN_CLIENT,
  FETCH_ME_DATA_ERROR,
  FETCH_ME_DATA_SUCCESS,
  LOGIN_FAILED,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
} from "modules/Auth/store/types";
import { _t } from "core/language";
import { useFetchCountCart } from "modules/Carts/hooks";
import { resetCountCart } from "modules/Carts/store/actions";
import { getCodeLangById } from "core/utils/helper";
import LoadingAI from "modules/AiChef/components/Loading";
const router = AppRouter;

const App = () => {
  const clientSetting = useSelector((state: any) => state.AppSettings);
  const upgradeRequired = useSelector(
    (state: any) => state.Common.upgradeRequired
  );
  const nativeReady = useSelector((state: any) => state.Common.nativeReady);
  const debugMode = useSelector((state: any) => state.Common.debugMode);
  const debugLog = useSelector((state: any) => state.Common.debugLog);
  const auth = useSelector((state: any) => state.Auth);

  const [debugUrl, setDebugUrl] = useState("");
  const [stateFetchMe, setStateFetchMe] = useState(false);
  const [loadingLoginSns, setLoadingLoginSns] = useState(false);

  const dispatch = useDispatch();
  

  const getAppSetting = useFetchAppSetting();

  const getCountCart = useFetchCountCart();

  const setupNativeReady = () => {
    settingApplication();
    if ((window as any)._APP_PLATFORM === "BROWSER")
      deviceStorage[config.appStorage].setItem(
        config.appPackage + "_FCM_TOKEN",
        (window as any)._APP_WEBPUSH_TOKEN
      );
    setupAxios();
    const token = deviceStorage[
      localStorage.getItem("storage_driver") || "session"
    ].getItem(config.appPackage + "_X_TOKEN");
    document.title = "Recipe Ai";
    if (getAppSetting) {
      getAppSetting();
    }
    if (token) {
      dispatch(fetchMe());
    } else {
      setStateFetchMe(true);
    }
  };
  const pwaRequiring = () => {
    return false;
  };

  const accessDevMode = () => {
    // Lấy query string từ URL hiện tại
    const queryString = window.location.search;
    // Tạo một đối tượng URLSearchParams từ query string
    const params = new URLSearchParams(queryString);
    // Lấy giá trị của tham số cụ thể từ URLSearchParams
    const devMode = params.get("devMode");

    // Log giá trị để kiểm tra
    return devMode === "true";
  };

  const goDebugUrl = () => {
    window.location.href = debugUrl;
  };

  const setAppInfo = () => {
    // console.log("Device connected:", (window as any)._APP_DEVICE_KEY);
    const deviceInfo = {
      _APP_FCM_TOKEN: (window as any)._APP_FCM_TOKEN,
      _APP_NATIVE_VERSION: (window as any)._APP_NATIVE_VERSION,
      _APP_DEVICE_KEY: (window as any)._APP_DEVICE_KEY,
      _APP_PLATFORM: (window as any)._APP_PLATFORM,
      _APP_AGENT: (window as any)._APP_AGENT,
      _APP_TYPE: (window as any)._APP_TYPE,
      _APP_LOC: (window as any)._APP_LOC,
      _APP_LANG: (window as any)._APP_LANG,
    };
    dispatch(setDebugLog(deviceInfo));
    dispatch(setNativeReady(deviceInfo));
  };

  const setBrowserInfo = () => {
    let deviceKey = localStorage.getItem(config.appPackage + "_DEVICE_KEY");
    if (!deviceKey) {
      deviceKey = uuid();
      localStorage.setItem(config.appPackage + "_DEVICE_KEY", deviceKey);
    }
    (window as any)._APP_FCM_TOKEN = "";
    (window as any)._APP_NATIVE_VERSION = process.env.REACT_APP_WEBVIEW_VERSION;
    (window as any)._APP_DEVICE_KEY = deviceKey;
    (window as any)._APP_PLATFORM = "BROWSER";
    (window as any)._APP_AGENT = "";
    (window as any)._APP_LOC = "VN";
    // console.log("DEVICEKEY: " + (window as any)._APP_DEVICE_KEY);
    setAppInfo();
  };
  useHandleError();
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (accessDevMode()) {
        // @ts-ignore
        window._APP_PLATFORM = "BROWSER";
        // @ts-ignore
        window._APP_LANG = "vi";
        // @ts-ignore
        window._APP_LOC = "VN";
        // @ts-ignore
        window._APP_WEBPUSH_TOKEN = "DEVMODE-FAKE_TOKEN";

        const el = document.getElementById("pwa-guide");
        if (el) el.style.display = "none";
      }
      if (
        ["ios", "android"].includes((window as any)._APP_PLATFORM.toLowerCase())
      ) {
        clearInterval(intervalId);
        (window as any)._APP_LOC = "VN";
        setAppInfo();
      } else if (
        ["browser"].includes((window as any)._APP_PLATFORM.toLowerCase())
      ) {
        clearInterval(intervalId);
        setBrowserInfo();
      } else {
        console.log("Device connecting...");
      }
    }, 100);
    
    // Clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    initApplication();
    // requestPermission("notification"); // native call Permission
    // (window as any).webViewRequestAdmob('SPLASH');
    setTimeout(() => {
      // @ts-ignore
      window.webViewDocumentReady();
    }, 10);
  }, []);

  useEffect(() => {
    if (
      nativeReady &&
      ["ios", "android"].includes((window as any)._APP_PLATFORM.toLowerCase())
    ) {
      setupNativeReady();
    }
    if (
      nativeReady &&
      (window as any)._APP_PLATFORM === "BROWSER" &&
      (window as any)._APP_WEBPUSH_TOKEN
    ) {
      // console.log(setupNativeReady, "setupNativeReady");

      setupNativeReady();
    }
  }, [nativeReady]);

  useEffect(() => {
    const setting = clientSetting;

    if (setting?.data?.configs?.refreshCache) {
      const refreshCacheLog = localStorage.getItem("hey_cooker_refresh_cache");
      console.log(205, setting.data.configs.refreshCache, refreshCacheLog)
      if (
        !refreshCacheLog ||
        refreshCacheLog != setting.data.configs.refreshCache
      ) {
        localStorage.setItem(
          "hey_cooker_refresh_cache",
          setting.data.configs.refreshCache
        );
        // @ts-ignore
        window.webViewRequestClearCache(215)
      }
    }
  }, [clientSetting]);

  useEffect(() => {
    const languages = clientSetting?.data?.languages || [];
    const code = getCodeLangById(auth?.userInfo?.lang_id, languages);
    if ([LOGIN_REQUEST].includes(auth?.type) && auth?.typeLogin !== "GMAIL") {
      setLoadingLoginSns(true);
    }
    if ([LOGIN_SUCCESS, LOGIN_FAILED].includes(auth?.type) && auth?.typeLogin !== "GMAIL") {
      setLoadingLoginSns(false);
    }
    if ([FETCH_ME_DATA_SUCCESS, FETCH_ME_DATA_ERROR].includes(auth?.type)) {
      setStateFetchMe(true);
    }
    if ([EXPIRE_TOKEN_CLIENT].includes(auth?.type)) {
      dispatch(resetCountCart())
    }
    if (code && [FETCH_ME_DATA_SUCCESS, LOGIN_SUCCESS].includes(auth?.type)) {
      if(getCountCart){
        getCountCart()
      }
      (window as any)._APP_LANG = code;
      settingApplication();
      if(auth?.type === FETCH_ME_DATA_SUCCESS){
        setupAxios();
      }
      // @ts-ignore
      window.webviewResponeLanguage({ lang: code });
      localStorage.removeItem('dataPolicy')
    }
  }, [auth?.type, clientSetting?.type]);

  console.log('upgradeRequired', upgradeRequired);
  
  return (
    <>
      {nativeReady && stateFetchMe ? (
        <>
          <RouterProvider router={router}></RouterProvider>
          <BrowserRouter>
            <AppPopup setting={clientSetting} />
          </BrowserRouter>
        </>
      ) : (
        <></>
      )}
      {upgradeRequired && (
        <CDialog
          open={true}
          submitText={_t("main.update_version_submit")}
          hideCancel
          handleSubmit={() => {
            (window as any).webViewRequestOpenMarket(upgradeRequired);
          }}
          hideClose
          classBtnSubmit={"p-4 mt-8 !bg-primary text-white ring-primary"}
          classNamechildren={"!px-12 !py-0"}
        >
          <h2 className="text-[17px] font-semibold">
            {_t("main.update_version_title")}
          </h2>
          <p
            className="text-sm font-normal mt-2"
            dangerouslySetInnerHTML={{
              __html: _t("main.update_version_content"),
            }}
          ></p>
        </CDialog>
      )}
      {debugMode > 6 && (
        <>
          <div id={"debugPanel"}>
            <div className="input-group mb-3">
              <input
                type="text"
                className="form-control"
                value={debugUrl}
                onChange={(e: any) => setDebugUrl(e.target.value)}
                placeholder="BASE_URL"
                aria-describedby="basic-addon2"
              />
              <div className="input-group-append">
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={goDebugUrl}
                >
                  GO
                </button>
              </div>
            </div>
            Log: {debugLog}
          </div>
        </>
      )}
      {loadingLoginSns && <LoadingAI />}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        // pauseOnHover
        theme="colored"
      />
      {pwaRequiring() && (
        <div id="pwa-splash">
          Hãy thêm <strong>Poan Market</strong> vào màn hình chính để trải
          nghiệm đầy đủ tính năng
          <Lottie className={"anim"} animationData={pwa} loop={true} />
        </div>
      )}
    </>
  );
};

export default App;
